export const NODE_TYPE = {
    ORGANIZATION: 'organization', // Организация
    COMPANY: 'company', // Компания', ТПП
    AREA: 'area', // Площадь
    EXPLORATION_AREA: 'exploration_area', // Разведочная площадь
    EXPLORATION_STRUCTURE: 'exploration_structure', // Разведочная структура
    ELEVATION: 'elevation', // Купол, поднятие
    LICENSE: 'license', // Лицензионный участок
    FIELD: 'field', // Месторождение
    PAD: 'pad', // Куст
    KNS: 'kns', // КНС
    SHAFT: 'shaft', // Ствол
    INDUSTRIAL: 'industrial', // Промышленные объекты
    DEVELOP: 'develop', // Объект разработки
    WELL: 'well', // Скважина', Прочие скважины
    Well_157: 157, // Нефтяная
    Well_158: 158, // Нефтяная в бездействии
    Well_159: 159, // Нефтяная в консервации
    Well_160: 160, // Нефтяная пьезометрическая
    Well_162: 162, // Нефтяная в ликвидации
    Well_163: 163, // Нагнетательная
    Well_164: 164, // Нагнетательная в бездействии
    Well_165: 165, // Нагнетательная в консервации
    Well_166: 166, // Нагнетательная пьезометрическая
    Well_167: 167, // Нагнетательная в ликвидации
    Well_178: 178, // Нефтяная остановленная
    Well_179: 179, // Нагнетательная остановленная
    Well_188: 188, // Водозаборная
    Well_189: 189, // Водозаборная в бездействии
    Well_190: 190, // Водозаборная в консервации
    Well_191: 191, // Водозаборная в ликвидации
    Well_192: 192, // Водозаборная остановленная
    Well_193: 193, // Водозаборная пьезометрическая
    Well_194: 194, // Газовая
    Well_195: 195, // Газовая в бездействии
    Well_196: 196, // Газовая в консервации
    Well_197: 197, // Газовая в ликвидации
    Well_198: 198, // Газовая остановленная
    Well_199: 199, // Газовая пьезометрическая
    Well_200: 200, // Газоконденсантная
    Well_201: 201, // Газоконденсантная в бездействии
    Well_202: 202, // Газоконденсантная в консервации
    Well_203: 203, // Газоконденсантная в ликвидации
    Well_204: 204, // Газоконденсантная остановленная
    Well_205: 205, // Газоконденсантная пьезометрическая
    Well_206: 206, // Поглощающая
    Well_207: 207, // Поглощающая в бездействии
    Well_208: 208, // Поглощающая в консервации
    Well_209: 209, // Поглощающая в ликвидации
    Well_210: 210, // Поглощающая остановленная
    Well_211: 211, // Поглощающая пьезометрическая
    Well_212: 212, // Специальная
    Well_213: 213, // Специальная в бездействии
    Well_214: 214, // Специальная в консервации
    Well_215: 215, // Специальная в ликвидации
    Well_216: 216, // Специальная остановленная
    Well_217: 217, // Специальная пьезометрическая
    PROFILE: 'profile', // Профайлы, Группы профайлов, Группы, Готовые проекты
    INFO: 'info', // Наличие информации, Виды информации
    RESEARCH: 'research', // Исследования
    RESEARCH_CORE: 'researchCore', // Исследования
    GROUP: 'group', // Группы в списках
    FILTER_ALERT: 'filterAlert', // Оповещение фильтра,
    PROJECT: 'project', // Проект
    OTHER: 'other', // Опробование скважин,
    GROUP_PAD: 'groupPad', // Группы кустов(Кусты)',
    GROUP_INDUSTRIAL_FACILITY: 'groupIndustrialFacility', // Группы промыленных объектов
    GROUP_OBJECTS: 'groupObjects', // Группы Объекты разработки
    OBJECT_DEV: 'objectDev', // Объект разработки
    FIELD_F: 'fieldF', // Месторождение (Вид дерева - месторождение)
    FIELD_A: 'fieldA', // Месторождение (Вид дерева - площади)
    AREA_A: 'areaA', // Площадь (Вид дерева - площади)
    COMPANY_L: 'companyL', // ТПП (Вид дерева - лицензионные участки)
    LICENSE_L: 'licenseL', // Лицензионный участок (Вид дерева - лицензионные участки)
    FIELD_L: 'fieldL', // Месторождение (Вид дерева - лицензионные участки)
    INDUSTRIAL_FACILITY: 'industrialFacility', // Промышленный объект
};
